export default __webpack_public_path__ + "static/media/supportBrand.f30c1a62.svg";